// Structured Data (JSON-LD) for SEO

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Tech Update",
  "url": "https://www.gettechupdate.com",
  "logo": "https://www.gettechupdate.com/logo.png",
  "description": "Tech Update provides affordable Flutter app development and website development services in Bhopal, Indore, Delhi, Mumbai, Bangalore, and across India. Expert mobile app development, web development, WordPress development, and UI/UX design at budget-friendly prices.",
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+91-8269277543",
    "contactType": "Customer Service",
    "email": "info@gettechupdate.com",
    "areaServed": "Worldwide",
    "availableLanguage": "English"
  },
  "sameAs": [
    "https://x.com/gettechupdate",
    "https://www.linkedin.com/company/14508055",
    "https://www.instagram.com/gettechupdate",
    "https://www.youtube.com/TechUpdate"
  ],
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "IN",
    "addressRegion": "Madhya Pradesh",
    "addressLocality": "Bhopal, Indore"
  },
  "areaServed": [
    {
      "@type": "City",
      "name": "Bhopal"
    },
    {
      "@type": "City",
      "name": "Indore"
    },
    {
      "@type": "City",
      "name": "Delhi"
    },
    {
      "@type": "City",
      "name": "Mumbai"
    },
    {
      "@type": "City",
      "name": "Bangalore"
    },
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "City",
      "name": "Hyderabad"
    },
    {
      "@type": "City",
      "name": "Chennai"
    },
    {
      "@type": "City",
      "name": "Kolkata"
    },
    {
      "@type": "City",
      "name": "Jaipur"
    }
  ]
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Tech Update",
  "url": "https://www.gettechupdate.com",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://www.gettechupdate.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export const serviceSchema = (serviceName, description, serviceType) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": serviceType,
  "name": serviceName,
  "description": description,
  "provider": {
    "@type": "Organization",
    "name": "Tech Update",
    "url": "https://www.gettechupdate.com"
  },
  "areaServed": {
    "@type": "Country",
    "name": "Worldwide"
  }
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Tech Update",
  "image": "https://www.gettechupdate.com/logo.png",
  "@id": "https://www.gettechupdate.com",
  "url": "https://www.gettechupdate.com",
  "telephone": "+91-8269277543",
  "priceRange": "$$",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "IN",
    "addressRegion": "Madhya Pradesh",
    "addressLocality": "Bhopal, Indore"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "",
    "longitude": ""
  },
  "areaServed": [
    {
      "@type": "City",
      "name": "Bhopal"
    },
    {
      "@type": "City",
      "name": "Indore"
    },
    {
      "@type": "City",
      "name": "Delhi"
    },
    {
      "@type": "City",
      "name": "Mumbai"
    },
    {
      "@type": "City",
      "name": "Bangalore"
    },
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "City",
      "name": "Hyderabad"
    },
    {
      "@type": "City",
      "name": "Chennai"
    },
    {
      "@type": "City",
      "name": "Kolkata"
    },
    {
      "@type": "City",
      "name": "Jaipur"
    }
  ],
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "opens": "09:00",
    "closes": "18:00"
  }
};

